import { render, staticRenderFns } from "./ExchangesTable.vue?vue&type=template&id=13eca2eb"
import script from "./ExchangesTable.vue?vue&type=script&lang=js"
export * from "./ExchangesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports